import { render } from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=template&id=2aee5e52&scoped=true"
import script from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"
export * from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"

import "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=style&index=0&id=2aee5e52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aee5e52"]])

export default __exports__